
<template>
  <div>
    <tour :steps="tourSteps">
    <PendenciaModal 
        :showModal="modalPendencia.showModal" 
        :titleText="modalPendencia.titleText"
        :infoText="modalPendencia.infoText"
        @confim-action="handleConfirmPendencia"
        @reject-action="handleRejectPendencia"
    />
    <ModalShowError
        :modalShow="modalError.showModal"
        :typeModal="modalError.typeModal"
        :infoText="modalError.infoText"
        :titleModal="modalError.titleModal"
        @confirmed="handleCloseModalError"
    />
    <page-header :screenName="screenName" :linkItems="linkItems" />
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
    <b-row v-if="!showLoading">
    <b-col>
      <section class="order-details" id="adesao">
          <b-card no-body class="invoice-preview-card">
            <b-card-body class="order-details-padding pb-0">
              <div class="logo-wrapper mb-3">
                <img :src="logo" alt="VacinaSESI" class="d-inline-block float-left" />

                <h2 v-text="screenName" class="d-inline-block float-right"></h2>
              </div>
              <div class="
                    d-flex
                    justify-content-between
                    flex-md-row flex-column
                    invoice-spacing
                    mt-0
                  ">
                <div v-if="responsible != null" class="d-inline-block float-left">
                  <p class="card-text mb-25 mt-2">
                    <strong>{{ campaignDescription }}</strong>
                  </p>
                </div>

                <div class="d-inline-block float-right mt-2">
                  <p class="m-0 text-right">
                    Data da realização: <strong>{{ dateAdhesion }}</strong>
                  </p>
                </div>
              </div>
              <div class="d-block mt-2" v-if="canceledAdhesion">
                <b-alert class="p-1" variant="danger" show>
                  <strong>Atenção! Esta é uma adesão cancelada.</strong>
                </b-alert>  
              </div>
            </b-card-body>
            <b-card-body v-if="order.sesi_responsavel != null" class="order-details-padding pt-0 pb-0">
              <div class="mb-2">
                <p class="card-text mb-25 mt-3">
                  {{ order.sesi_responsavel.descricao }}
                </p>
                <p class="card-text mb-25 mt-2">
                  {{adhesion ? adhesion.empresa_endereco.descricao : company.descricao}}
                </p>
                <p class="card-text mb-25">
                  {{adhesion ? adhesion.empresa_endereco.logradouro : company.logradouro}}, n° {{adhesion ? adhesion.empresa_endereco.numero : company.numero}}, {{ adhesion ? adhesion.cidade.nome : company.cidade}},
                  {{adhesion ? adhesion.cidade.uf : company.uf}}, {{adhesion? adhesion.cep :    company.cep | VMask("#####-###")}}

                </p>
                <p class="card-text mb-25" v-if="order.sesi_responsavel.contato != null">
                  {{ order.sesi_responsavel.contato.email_responsavel }}
                </p>
              </div>
            </b-card-body>

            <hr class="mx-2"/>
            <b-card-body v-if="company != null" class="order-details-padding pt-0 pb-0 mt-2">
              <div class="mb-2">

                <h6 v-if="company.documento.length == 14">CNPJ {{ company.documento | formataCpfCnpj }}</h6>
                <h6 v-else>CPF {{ company.documento | formataCpfCnpj }}</h6>
                <p class="card-text mb-1">
                  {{ company.nome_empresa }}
                </p>

                <h6 v-if="company.empresa_endereco">{{adhesion ? adhesion.empresa_endereco.descricao : company.descricao}}</h6>
                <p class="card-text mb-25" v-if="adhesion">
                  {{ adhesion.logradouro }}, {{ adhesion.bairro }}
                </p>
                <p class="card-text mb-25" v-if="adhesion && adhesion.cidade">
                  {{ adhesion.cidade.nome }}/{{ adhesion.cidade.uf }}
                </p>
                <p class="card-text mb-25" v-if="address">
                  {{ address.nome }}/{{ address.uf }}
                </p>
              </div>
            </b-card-body>

            <b-card-body v-if="company != null" class="order-details-padding pt-0">
              <div class="mb-4">
                <h6>Aos cuidados:</h6>
                <p class="mb-25 font-weight-bold" v-if="company.empresa_contato && company.empresa_contato.length > 0">
                  {{ contact_adress ? contact_adress.nome : company.responsavel }}
                </p>
                <p class="card-text mb-25" v-if="company.empresa_contato && company.empresa_contato.length > 0">
                  {{ contact_adress ? contact_adress.email : company.email }}
                </p>
                <p class="card-text mb-25" v-if="company.empresa_contato && company.empresa_contato.length > 0">
                  {{ formatPhone }} 
                </p>
              </div>
            </b-card-body>

            <ViewPriceRangePurchase class="mb-2" v-if="priceRangePricing.length" :doses="priceRangePricing" :info="order" />
            <ManualOrderDetailsTable v-if="manualPricing.length" :doses="manualPricing" />

            <b-card-footer class="order-details-padding pt-1">
              <div class="order-details-footer">
                <div class="order-details-emit">
                  <p>
                    <span class="order-details-footer-title">Pedido realizado por:</span>
                    {{ issuedBy }}
                  </p>
                </div>
                <div class="order-details-canceled-container mb-2" v-if="canceledAdhesion">
                    <p>
                      <span class="order-details-footer-title">Adesão cancelada por:</span>
                      {{ canceledBy }}
                    </p>
                    <p>
                      <span class="order-details-footer-title">Data/Hora do cancelamento:</span>
                      {{ canceledDate }}
                    </p>
                  </div>

                <div>
                  <h6 v-if="adhesionNumber" class="order-details-footer-title">Este pedido refere-se a adesão #{{
                    adhesionNumber }}</h6>
                </div>
              </div>
            </b-card-footer>
          </b-card>
      <PdfAdesaoModal :modoCriacao="false" :modalShow="showModal.show" :pdf="pdf" @fechar="fecharModal" />
    </section>
  </b-col>
  <b-col cols="12" md="4" xl="3" class="invoice-actions">
    <b-card class="order-details-pd-btn">
      <b-button variant="btn custom-outline-blue" v-if="term" block @click.prevent="visualizarTermo">
        Visualizar termo
      </b-button>
      <b-button variant="outline-danger" class="custom-outline-red btn" block @click="openModalPendencia()" v-if="canCancelAdhesion && !canceledAdhesion">
        Cancelar adesão
      </b-button>
      <b-button variant="custom-blue" block @click="editOrderOrBack()">
        Voltar
      </b-button>
    </b-card>
  </b-col>
</b-row>
</b-overlay>
    </tour>
  </div>
</template>

<script>
import { BCol, BRow, BButton, BCard, BOverlay, BCardFooter, BCardBody, BAlert } from "bootstrap-vue";
import ViewPriceRangePurchase from '@/views/custom-pages/adhesion-price-range/view/ViewPriceRangePurchase.vue'
import { 
    AdesaoGetChooseOrder,
    AdesaoGetChooseCampaign,
    AdesaoGetChooseCompany
} from '@/views/custom-pages/adesao/Purchase/adesaoHelpers.js'
import PageHeader from "@/views/components/custom/page-header/PageHeader.vue";
import { actions, subjects } from "@/libs/acl/rules";
import PendenciaModal from '@/views/components/custom/modals/adesao/PendenciaModal.vue';
import ModalShowError from '@/views/components/custom/modals/ModalShowError.vue';
import logo from "@/assets/custom-images/vacina-sesi-logo-azul.svg";
import PdfAdesaoModal from "@/views/custom-pages/adesao/components/PdfAdesaoModal/PdfAdesaoModal.vue";
import moment from "moment";
import ManualOrderDetailsTable from "./View/ManualOrderDetailsTable.vue";
import detailsPurchaseMixin from "../tour-mixins/detailsPurchaseMixin";

export default {
  name: 'OrderDetailsIndex',
  components: {
    ViewPriceRangePurchase,
    PageHeader,
    BCol,
    BRow,
    BButton,
    BCard,
    PendenciaModal,
    ModalShowError,
    BOverlay,
    BCardFooter,
    PdfAdesaoModal,
    BCardBody,
    ManualOrderDetailsTable,
    BAlert
  },
  mixins: [detailsPurchaseMixin],
  computed: {
    chooseOrder() {
      return AdesaoGetChooseOrder()
    },
    manualPricing() {
      return this.doses.filter(dose => dose.id_desconto_progressivo_faixa === null)
    },
    priceRangePricing() {
      return this.doses.filter(dose => dose.id_desconto_progressivo_faixa !== null)
    },
    screenName() {
      return `Pedido #${this.chooseOrder.numero_pedido}`
    },
    term() {
      return this.order.termo;
    },
    canceledAdhesion() {
      return this.order?.adesao?.situacao == 'Cancelado'
    },
    company() {
      return this.order.empresa;
    },
    responsible() {
      return this.order.sesi_responsavel;
    },
    responsibleEmail() {
      return this.responsible.contato != null && this.responsible.contato.email 
        ? this.responsible.contato.email
        : null
    },
    adhesion() {
      return this.order.adesao;
    },
    address() {
      if (AdesaoGetChooseCompany()) {
        return AdesaoGetChooseCompany().endereco;
      }
    },
    contact_adress() {
      if (AdesaoGetChooseCompany()) {
        return AdesaoGetChooseCompany().contato;
      }

      if(this.order.empresa.empresa_endereco){
        let endereco = this.order.empresa.empresa_endereco.find(e => 
        e.id_cidade === this.order.adesao.id_cidade &&
        e.logradouro == this.order.adesao.logradouro &&
        e.bairro == this.order.adesao.bairro &&
        e.numero == this.order.adesao.numero &&
        e.cep == this.order.adesao.cep
        )
        return endereco ? endereco.contato : null
      }
    },
    issuedBy() {
      return this.order?.processado_por?.nome;
    },
    adhesionNumber() {
      return this.order?.adesao?.numero;
    },
    formatPhone() {
      const tel = this.contact_adress?.telefone || this.company?.telefone_empresa;
      if (!tel) return '';
      const phone = tel.replace(/\D/g, '');
      if (phone.length === 11) {
        return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else if (phone.length === 10) {
        return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else {
        return tel;
      }
    },
    campaignDescription() {
      return AdesaoGetChooseCampaign().descricao;
    },
    dateAdhesion() {
      return moment(this.order?.adesao?.data_prevista).format("DD/MM/YYYY");
    },
    canceledBy() {
      return this.order?.adesao?.cancelado_por;
    },
    canceledDate() {
      return  moment(String(this.order?.adesao?.data_alteracao)).format("DD/MM/YYYY HH:mm")
    },
    doses() {
      return this.order.doses ?? [];
    },
  },
  data() {
    return {
        logo,
        linkItems: [
        {
          name: "Adesão",
          routeName: "acceptances",
        },
        {
          name: "Aderir Campanha",
          routeName: "",
        },
        {
          name: "Ver Detalhes",
          active: true,
        },
      ],
      showLoading: true,
      order: {},
      canCancelAdhesion: this.$can(actions.EXCLUIR, subjects.ADESAO_SESI),
      modalPendencia: {
        showModal: false,
        titleText: "Você confirma o cancelamento?",
        infoText: 'Ao clicar em "Sim", você estará cancelando esta adesão. As doses aqui não estarão mais reservadas para esta empresa e poderão ser utilizadas em novas adesões. Esta ação não pode ser desfeita.',
      },
      modalError: {
        showModal: false,
        typeModal: 'error',
        titleModal: '',
        infoText: '',
      },
      showModal: {
        show: false,
      },
      pdf: {
        blob: null,
        name: null,
      },
    }
  },
  methods: {
    async getChooseOrder() {
      const {data} = await this.$http
        .get(this.$api.pedidoAdesaoPrecificacoes(this.chooseOrder.id_pedido), {
            params: {
                id_empresa: this.chooseOrder.id_empresa,
                id_adesao: this.chooseOrder.id_adesao,
                id_campanha: AdesaoGetChooseCampaign().id_campanha
            }
        })

        this.order = data
        this.showLoading = false
    },
    editOrderOrBack() {
      let name = "acceptances";
      this.$router.push({ name }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    visualizarTermo() {
      const tipoTermo = this.order.termo.tipo;
      this.$http.get(this.$api.downloadAdhesionContract(AdesaoGetChooseOrder().id_campanha), {
        responseType: "blob",
        params: {
          tipo: tipoTermo,
          id_adesao: AdesaoGetChooseOrder().id_adesao
        }
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });

          this.pdf.blob = URL.createObjectURL(blob);
          this.pdf.nome = response.headers["content-name-file"];
          this.openModal();
        })
        .catch(() => {
          this.$helpers.modalErroServidorPadrao();
        });
    },
    openModal() {
      this.showModal.show = true;
    },
    openModalPendencia() {
      this.modalPendencia.showModal = true;
    },
    handleConfirmPendencia() {
      if (!this.processando) {
        this.processando = true
        this.cancelAdhesion();
      }
    },
    cancelAdhesion() {
      const parameters = {
        id_adesao: AdesaoGetChooseOrder().id_adesao
      }
      this.$http.put(this.$api.cancelAdhesion(), parameters)
        .then(() => { 
            this.closeModalPendencia();
            this.$router.push(
              { 
                name: 'acceptances'
              }
            );
            this.processando = false
        })
        .catch(({ response }) => {
          this.closeModalPendencia();
          if (response && response.status === 400) {
            this.modalError.titleModal = 'Erro ao cancelar adesão';
            this.modalError.infoText = response.data?.errors || 'Não foi possível cancelar esta adesão.';
            this.modalError.showModal = true;
          } else {
            this.$helpers.modalErroServidorPadrao();
          }
          this.processando = false
        })
    },
    handleRejectPendencia() {
        this.modalPendencia.showModal = false;
    },
    handleCloseModalError() {
        this.modalError.showModal = false;
    },
    fecharModal() {
      this.showModal.show = false;
    },
    closeModalPendencia() {
      this.modalPendencia.showModal = false;
    },
  },
  mounted() {
    this.getChooseOrder()
  }
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "./style.scss";

.contract {
  a {
    color: #2772c0;
  }

  .custom-control-input:checked~.custom-control-label::before {
    border-color: #2772c0 !important;
    background-color: #2772c0 !important;
  }
}
.order-details-canceled-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>